
import "./gatePassPopUp.css";
import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { useState } from 'react';
import { getLocalStorageItem } from "../../../common/localStorageUtils";

function GatePassPopUp() {

  
  return (
        <div className='gate-pass-popup-container'>
            <Container fluid>
                <Row>
                    <Col xs={12} md={12}>
                        <div>
                            <form>
                               <div className='headingStylePIT'>Enter Vehicle Details</div>
                               <Row>
                                    <Col xs={12} md={6}>
                                        <div className="consignment-pick-up-consignment-label" >Consignment No</div>
                                        <input  required className='consignment-pick-up-textfields' name="" ontype="text" />
                                        <div className="consignment-pick-up-consignment-label" >Vehicle No</div>
                                        <input  required className='consignment-pick-up-textfields' name="" ontype="text" />
                                        <div className="consignment-pick-up-consignment-label" >Driver Name</div>
                                        <input  required className='consignment-pick-up-textfields' name="" ontype="text" />
                                        <div className="consignment-pick-up-consignment-label" >Driver Contact</div>
                                        <input  required className='consignment-pick-up-textfields' name="" ontype="text" />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <div className="consignment-pick-up-consignment-label" >Gate Entry Time</div>
                                        <input  required className='consignment-pick-up-textfields' name=""  />
                                        <div className="consignment-pick-up-consignment-label" >Gate Exit Time</div>
                                        <input  required className='consignment-pick-up-textfields' name=""  />
                                        <div className="consignment-pick-up-consignment-label" >Verification Status</div>
                                        <input  required className='consignment-pick-up-textfields' name=""  />
                                        <button className='gate-pass-popover-Btn' type='submit'>Add Details</button>
                                    </Col>
                               </Row>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
  );
};
export default GatePassPopUp;
